module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/ea7ad78cb4b50116c542ca15f8cafd69.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/past_certificates/silver.png
// module id = OIPS
// module chunks = 0